import { removeAttachedService } from './attachedServices';
import { drawCart, setCartLoading } from '../legacyCart';
import { getStoreCurrency } from '../shopify/getStoreCurrency';
import { filterAndMapAttributes } from '@jbhi-fi/apis/src/utils/filterAndMapAttributes';
import { trackRemoveFromCartShopify } from './trackRemoveFromCartShopify';
import { ShopifyStorefrontClient } from '../../api/shopify/ShopifyStorefrontClient';
import { transformStorefrontCartToJbCart } from './transformStorefrontCartToJbCart';

const storefrontClient = new ShopifyStorefrontClient();

export const removeAttachedServiceOffering = async (
  attachedServiceLineId: string,
  serviceLink?: string,
  googleTagManager?: { [key: string]: any },
  location?: string,
  isValid?: boolean
) => {
  try {
    if (serviceLink) {
      setCartLoading(true);
      removeAttachedService(serviceLink);

      let cart = await storefrontClient.removeFromCart(attachedServiceLineId);
      let transformedCart = transformStorefrontCartToJbCart(cart);
      const primaryItem = transformedCart?.items.find(item => item.properties._serviceLink === serviceLink);
      if (primaryItem) {
        delete primaryItem.properties?._serviceLink;
        delete primaryItem.properties?._isAttachedService;
        delete primaryItem.properties?._legacy_addons_line_key;
        cart = await storefrontClient.updateCartLine(
          primaryItem.line_id,
          undefined,
          filterAndMapAttributes(primaryItem.properties)
        );
        transformedCart = transformStorefrontCartToJbCart(cart);
      }
      drawCart(transformedCart);
    }

    //TODO: OLD GA TRACKING TO BE REMOVED
    if (googleTagManager) {
      window.dataLayer.push({
        event: 'removeFromCart',
        ecommerce: {
          currencyCode: getStoreCurrency(),
          remove: {
            isValid,
            actionField: {
              list: location,
            },
            products: [
              {
                ...googleTagManager,
              },
            ],
          },
        },
      });
    }
  } catch (e) {
    console.error(e);
  }
};
